import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { ResponsiveBlockGrid } from "../../../shared/components/ResponsiveBlockGrid/ResponsiveBlockGrid";
import { ResponsiveBlockGridItem } from "../../../shared/components/ResponsiveBlockGridItem/ResponsiveBlockGridItem";
import { StatsItem } from "../StatsItem/StatsItem";
import type { IStatsStandardProps } from "./StatsStandard.props";

export const StatsStandard = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  spacing,
}: IStatsStandardProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <BlockContainer anchorId={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12 md:gap-16">
        {hasCommonContent ? (
          <div className="flex flex-col gap-8">
            <BlockCommonContent
              alignment={alignment}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
              headingLevel="h2"
            />
            {buttons?.length ? <BlockActions actions={buttons} alignment={alignment} /> : null}
          </div>
        ) : null}
        <ResponsiveBlockGrid columnCount={columnCount} className="gap-x-6 gap-y-10">
          {items.map((item, index) => (
            <ResponsiveBlockGridItem key={index}>
              <StatsItem description={item.description} label={item.label} value={item.value} />
            </ResponsiveBlockGridItem>
          ))}
        </ResponsiveBlockGrid>
      </div>
    </BlockContainer>
  );
};

StatsStandard.displayName = "Stats::StatsStandard";
